/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import { Stack, Button, Container, Typography, Card, Box, MenuItem } from '@mui/material';
import TableStyle from '../../ui-component/TableStyle';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditPackages from './EditPackages';
import Iconify from '../../ui-component/iconify';
import AddPackages from './AddPackages';
import { getApi, postApi, patchApi } from '../services/api';
import { toast } from 'react-toastify';
import DeletePackage from './DeletePackage';
import { useNavigate } from 'react-router';

// ----------------------------------------------------------------------

const AdminPackages = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const navigate = useNavigate();

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const addPackagesData = async (data) => {
    const response = await postApi(`api/packages/add`, data);
    if (response && response.status === 201) {
      getAllPackagesData();
    }
  };

  const getAllPackagesData = async () => {
    try {
      const response = await getApi(`api/packages/getAllPackages`);
      console.log("response for packages ======>",response);

      if (response && response.status === 200) {
        setPackageData(response?.data?.packagesAllData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // edit packages api
  const editPackagesData = async (values) => {
    try {
      const data = values;
      const result = await patchApi(`api/packages/edit/${editData?._id}`, data);

      if (result && result.status === 200) {
        toast.error('Package Modified Successfully');

        getAllPackagesData();
      }
    } catch (error) {
      toast.error('Cannot Modify Package');
    }
  };

  useEffect(() => {
    getAllPackagesData();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      field: '_id',
      headerName: 'S.No.',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize',
      valueGetter: (index) => index.api.getRowIndexRelativeToVisibleRows(index.row._id) + 1
    },
    {
      field: 'title',
      headerName: 'Title',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const handleOpenView = () => {
          navigate(`/dashboard/packages/view/${params.row._id}`);
        };
        return <Box onClick={handleOpenView}>{params.value}</Box>;
      }
    },

    {
      field: 'description',
      headerName: 'Description',
      flex: 1
    },

    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box> Rs {params.value}</Box>;
      }
    },

    {
      field: 'days',
      headerName: 'Days',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      // eslint-disable-next-line arrow-body-style
      renderCell: (params) => {
        const handleEditClick = async (data) => {
          setEditData(data);
          handleOpenEdit();
        };
        const handleDeleteClick = async (id) => {
          setDeleteId(id);
          handleOpenDelete();
        };
        return (
          <>
            <>
              <MenuItem onClick={() => handleEditClick(params?.row)} disableRipple>
                <EditIcon  />
              </MenuItem>
              <MenuItem onClick={() => handleDeleteClick(params.row._id)} sx={{ color: 'red' }} disableRipple>
                <DeleteIcon/>
              </MenuItem>
            </>
          </>
        );
      }
    }
  ];

  return (
    <>
      <EditPackages open={openEdit} editData={editData} handleClose={handleCloseEdit} editPackagesData={editPackagesData} />

      <AddPackages open={openAdd} handleClose={handleCloseAdd} addPackagesData={addPackagesData} />
      <DeletePackage open={openDelete} handleClose={handleCloseDelete} id={deleteId} getAllPackagesData={getAllPackagesData} />
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Packages Lists</Typography>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
              New Package
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Packages ( {packageData?.length} )
              </Typography>
              <DataGrid
                rows={packageData ?? []}
                columns={columns}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default AdminPackages;
